{
  "instances": {
    "configprops": {
      "label": "Configuration Properties",
      "no_properties_set": "Keine Konfiguration gefunden."
    }
  }
}
